const button = {
  default: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'white',
    cursor: 'pointer',
    paddingTop: 's8',
    paddingBottom: 's8',
    paddingLeft: 's4',
    paddingRight: 's4',
    marginRight: 's8',
    fontSize: 'fs25',
    lineHeight: 'body',
    fontWeight: 'regular',
    '&:hover, &:focus': {
      borderBottomColor: 'primary',
      outline: 'none'
    },
    '&[aria-expanded="true"]': {
      borderBottomColor: 'coolGrey.30',
      '& > .accordionButtonHasArrow': {
        transform: 'rotate(90deg)'
      }
    }
  },
  inverse: {
    paddingTop: 's16',
    paddingBottom: 's16',
    paddingLeft: 's8',
    paddingRight: 's8',
    borderBottomWidth: '1px',
    borderBottomColor: 'indigo.60',
    borderBottomStyle: 'solid',
    '&:hover, &:focus': {
      borderBottomColor: 'primary',
      backgroundColor: 'indigo.90'
    },
    '&[aria-expanded="true"]': {
      borderBottomColor: 'white'
    },
    backgroundColor: 'indigo.70',
    color: 'white'
  }
};

export const buttonVariants = Object.keys(button) as ButtonType[];
export type ButtonType = 'default' | 'inverse';

export default button;
